import { useState, useEffect } from 'react';
import { useAuth } from './useAuth';
import { getRoleFromUser, isOwnerRole } from '../types/roles';

interface OwnerState {
  isOwner: boolean;
  loading: boolean;
}

export function useOwner() {
  const { user } = useAuth();
  const [ownerState, setOwnerState] = useState<OwnerState>({
    isOwner: false,
    loading: true,
  });

  useEffect(() => {
    if (!user) {
      setOwnerState({ isOwner: false, loading: false });
      return;
    }

    setOwnerState({ isOwner: isOwnerRole(getRoleFromUser(user)), loading: false });
  }, [user]);

  return ownerState;
}
